<div
  class="products-holder"
  [class.cart-not-empty]="isCartNotEmpty"
  inventoryEvents
  [tagName]="'pos-virtual-product-item'"
  (touchStart)="handleTouchStart($event)"
  (touchEnd)="handleTouchEnd($event)"
>
  <virtual-scroller #virtualScroll [items]="productItemList()" [parentScroll]="parentScroll" [enableUnequalChildrenSizes]="true">
    @for (item of virtualScroll.viewPortItems; track item.uuid || $index) {
      <div>
        <pos-virtual-product-group
          [productItemGroup]="item"
          [cellsQuantity]="cellsQuantity"
          [cellWidth]="cellWidth"
        ></pos-virtual-product-group>
      </div>
    }
  </virtual-scroller>
  @if (!productItemList().length) {
    <ng-content></ng-content>
  }
</div>
